// extracted by mini-css-extract-plugin
export default {"wrapper":"BlogAddAccessChecker_wrapper__9sxej","space":"BlogAddAccessChecker_space__yA34w","title":"BlogAddAccessChecker_title__bSbKX"};